import { useContext } from 'react';
import { ContextGameMechanicEdit } from 'src/contexts';

// ========================================================================== //
// ================================= LOGIC ================================== //
// ========================================================================== //

/**
 * @description - The hook for the game component. This is containing all
 * necessary lifecycle methods and variables.
 */
const useGameEditMechanic = () => {
  const context = useContext(ContextGameMechanicEdit);

  if (!context) throw new Error(
    'Game context must be use inside GameBaseProvider'
  );

  return context;
};

export default useGameEditMechanic;
